import { CommunicationCategoryCodes, QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";

export const COMMUNICATION_INBOX_CATEGORY = `${QuiltedHealthCodeSystems.CommunicationCategories}|${CommunicationCategoryCodes.Inbox}`;
export const COMMUNICATION_THREAD_CATEGORY = `${QuiltedHealthCodeSystems.CommunicationCategories}|${CommunicationCategoryCodes.Thread}`;
